// import { ReactComponent as ClaimsIconSVG } from '@/assets/icons/New-Claim.svg';
import { ReactComponent as ClaimsIconSVG } from '@/assets/icons/claim.svg';
import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import ContactPageIcon from '@mui/icons-material/ContactPage';

export const ProspectsIcon = ({ bgColor = '#D0ECFB', width = '24px', height = '24px', ...props }) => {
	const { color } = props;

	return (
		<SvgIcon
			{...props}
			sx={{
				backgroundColor: bgColor,
				width: width,
				height: height,
				borderRadius: 2,
				padding: '0.1em',
			}}
		>
			<ContactPageIcon sx={{ color: 'white', fill: 'none', stroke: 'white', }} />
		</SvgIcon>
	);
};






